import { useState, useCallback } from "react";

/**
 * Create / edit / delete modal state shared by the CRUD list pages: the
 * selected row, the row pending deletion, and the three open flags.
 */
export const useCrudModals = <T>() => {
  const [selected, setSelected] = useState<T | null>(null);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [toDelete, setToDelete] = useState<T | null>(null);

  const openCreate = useCallback(() => {
    setSelected(null);
    setShowCreate(true);
  }, []);

  const openEdit = useCallback((item: T) => {
    setSelected(item);
    setShowEdit(true);
  }, []);

  const openDelete = useCallback((item: T) => {
    setToDelete(item);
    setShowDelete(true);
  }, []);

  const closeCreate = useCallback(() => {
    setShowCreate(false);
    setSelected(null);
  }, []);

  const closeEdit = useCallback(() => {
    setShowEdit(false);
    setSelected(null);
  }, []);

  const closeDelete = useCallback(() => {
    setShowDelete(false);
    setToDelete(null);
  }, []);

  return {
    selected,
    toDelete,
    showCreate,
    showEdit,
    showDelete,
    openCreate,
    openEdit,
    openDelete,
    closeCreate,
    closeEdit,
    closeDelete,
  };
};
